import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-liquid-glass',
  templateUrl: './liquid-glass.component.pug',
  styleUrls: ['./liquid-glass.component.sass']
})
export class LiquidGlassComponent implements OnInit {
  constructor() { }

  ngOnInit(): void {
  }
}
